import React from 'react';
import { observer } from 'mobx-react-lite';
import cateringStore from '../../../stores/CateringStore';

const AddOnsSelector: React.FC = observer(() => {
  const { addons, selectedAddOns, toggleAddOn, selectedPackageSlug } =
    cateringStore;

  // For convenience, define the add-on IDs that only apply to fish-taco-fiesta
  const fishAddOnSlugs = [
    'add-shrimp-protein',
    'add-octopus-protein',
    'shrimp-or-octopus-choice',
  ];

  // Check if the user selected the fish-taco-fiesta package
  const isFishPackage = selectedPackageSlug === 'fish-taco-fiesta';

  // Filter the addOns array:
  // - If an addOn is fish-specific AND not on fish-taco-fiesta, hide it
  // - Otherwise, display it
  const visibleAddOns = addons.filter((addOn) => {
    if (fishAddOnSlugs.includes(addOn.slug_id)) {
      // Show only if fish package
      return isFishPackage;
    }
    return true; // show universal add-ons
  });

  return (
    <div className="my-8">
      <h2 className="text-2xl font-charles text-maroon mb-4">
        3) Select Add-Ons
      </h2>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {visibleAddOns.map((addOn) => (
          <label
            key={addOn.slug_id}
            className={`
              flex items-center bg-white border p-3 rounded
              transition
              ${selectedAddOns[addOn.slug_id] ? 'border-maroon' : 'border-sea'}
              hover:border-maroon
            `}
          >
            <input
              type="checkbox"
              checked={!!selectedAddOns[addOn.slug_id]}
              onChange={() => toggleAddOn(addOn.slug_id)}
              className="mr-3"
            />
            <div>
              <span className="font-charles text-lg text-maroon">
                {addOn.label}
              </span>
              <p className="text-sm font-prosto text-sea ml-1">
                +${Number(addOn.pricePerPerson).toFixed(2)}/person
              </p>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
});

export default AddOnsSelector;
